import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { StrategyContext } from "./Context/StrategyContext";
import { Box, FormControl, InputLabel, Select, OutlinedInput, MenuItem, Button, IconButton, Typography, TextField, Stack, Menu, ListItemIcon } from "@mui/material";
import { Menu as MenuIcon, SaveAs as SaveAsIcon, Save as SaveIcon, FileDownload as FileDownloadIcon } from "@mui/icons-material";
import MuiAlert from "@mui/material/Alert";

const WEBAPI = process.env.REACT_APP_WEB_API;
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const QuickStrategyPerformanceToolbar = ({ setNewPortfolioID, maxRanking, setNewMidPoint }) => {
  const [portfolioID, setPortfolioID] = React.useState("");
  const [portfolioList, setPortfolioList] = React.useState([]);
  const [midPoint, setMidPoint] = React.useState(0);
  const [isMidPointChanged, setIsMidPointChanged] = React.useState(false);

  useEffect(() => {
    const newMidPoint = Math.round(maxRanking / 2);
    // console.log("newMidPoint: ", newMidPoint);
    setMidPoint(newMidPoint);

    getPortfolioList();
  }, []);

  const getPortfolioList = () => {
    axios
      .get(`${WEBAPI}/quickportfolio`)
      .then((res) => {
        let noPortfolio = { id: "0", name: "None" };
        res.data.unshift(noPortfolio);
        setPortfolioList(res.data);

        // console.log('portfolio list: ', res.data);

        if (res.data.length > 0 && portfolioID === "") {
          setPortfolioID(res.data[0].id);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        // setLoading(false)
      });
  };

  const handlePortfolioChange = (event) => {
    setPortfolioID(event.target.value);
    setNewPortfolioID(event.target.value);
  };

  const handleMidPointChange = (value) => {
    setMidPoint(value);
    setIsMidPointChanged(true);
  };

  const handleUpdateRankingMidpoint = () => {
    setIsMidPointChanged(false);
    setNewMidPoint(midPoint)
  }

  return (
    <>
      <Stack direction="row">
        <Box sx={{ ml: 0 }}>
          <FormControl sx={{ m: 0, width: 220 }} size="small">
            <InputLabel>Compare with Portfolio</InputLabel>
            <Select value={portfolioID} onChange={handlePortfolioChange} input={<OutlinedInput label="Compare with Portfolio" />}>
              {portfolioList.map((p) => (
                <MenuItem key={p.id} value={p.id}>
                  {p.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <Box sx={{ ml: 2 }}>
          <FormControl sx={{ m: 0, width: 120 }} size="small">
            <TextField label="Alert Point" value={midPoint} onChange={(e) => handleMidPointChange(e.target.value)} size="small" type="number" />
          </FormControl>
        </Box>

        <Box sx={{ ml: 2 }}>
          <Button variant="contained" size="small" color="success" disabled={!isMidPointChanged} onClick={handleUpdateRankingMidpoint}>
            Update Alert Point
          </Button>
        </Box>
      </Stack>
    </>
  );
};

export default QuickStrategyPerformanceToolbar;
